import 'css-chunksrc/client/pages/projectPage/synthesisPage/reports/reportsList/report/styles.scss';export default {
  "report": "_report_56wjd_1",
  "headerItem": "_headerItem_56wjd_11",
  "indicators": "_indicators_56wjd_24",
  "name": "_name_56wjd_28",
  "submissionDate": "_submissionDate_56wjd_34",
  "author": "_author_56wjd_40",
  "reportIcon": "_reportIcon_56wjd_48",
  "authorName": "_authorName_56wjd_56"
};